import React from "react";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import RaindropCopyrightDeclaration from "../../../ui-components/raindrop-copyright-declaration/raindrop-copyright-declaration";
import { useState } from "react";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";
import { Size } from "../../../logic/enums.ts";

const RaindropCircleAnimated = () => {
  const organisationID_A = "organisation_0936773D-02C6-4AFB-BCEF-03984D03EBFF";
  const organisationID_B =
    "organisation_76CFE4A217-F6D0-4E69-B393-215EB8B38B8B";
  const organisationID_C = "organisation_B628EB2B-ED3A-4785-8866-BD0C1784124C";

  const states = [
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 100,
        oldValue: 100,
        selected: false,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 90,
        oldValue: 90,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 10,
        oldValue: 10,
        selected: false,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 90,
        oldValue: 90,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 10,
        oldValue: 10,
        selected: true,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 60,
        oldValue: 60,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 40,
        oldValue: 40,
        selected: true,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 60,
        oldValue: 60,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 40,
        oldValue: 40,
        selected: false,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 55,
        oldValue: 55,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 35,
        oldValue: 35,
        selected: false,
      },
      {
        id: organisationID_C,
        organisationId: organisationID_C,
        value: 10,
        oldValue: 10,
        selected: false,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 55,
        oldValue: 55,
        selected: true,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 35,
        oldValue: 35,
        selected: false,
      },
      {
        id: organisationID_C,
        organisationId: organisationID_C,
        value: 10,
        oldValue: 10,
        selected: false,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 35,
        oldValue: 35,
        selected: true,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 45,
        oldValue: 45,
        selected: false,
      },
      {
        id: organisationID_C,
        organisationId: organisationID_C,
        value: 20,
        oldValue: 20,
        selected: false,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 35,
        oldValue: 35,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 45,
        oldValue: 45,
        selected: false,
      },
      {
        id: organisationID_C,
        organisationId: organisationID_C,
        value: 20,
        oldValue: 20,
        selected: false,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 35,
        oldValue: 35,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 45,
        oldValue: 45,
        selected: false,
      },
      {
        id: organisationID_C,
        organisationId: organisationID_C,
        value: 20,
        oldValue: 20,
        selected: true,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 25,
        oldValue: 25,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 35,
        oldValue: 35,
        selected: false,
      },
      {
        id: organisationID_C,
        organisationId: organisationID_C,
        value: 40,
        oldValue: 40,
        selected: true,
      },
    ],
    [
      {
        id: organisationID_A,
        organisationId: organisationID_A,
        value: 25,
        oldValue: 25,
        selected: false,
      },
      {
        id: organisationID_B,
        organisationId: organisationID_B,
        value: 35,
        oldValue: 35,
        selected: false,
      },
      {
        id: organisationID_C,
        organisationId: organisationID_C,
        value: 40,
        oldValue: 40,
        selected: false,
      },
    ],
  ];

  const [stateIndex, setStateIndex] = useState(0);

  setTimeout(() => {
    const newStateIndex = Math.min(stateIndex + 1, states.length - 1);
    setStateIndex(newStateIndex);
  }, 700);

  return (
    <div className="flex flex-col gap-2 items-center ">
      <RaindropCircle sausageValues={states[stateIndex]} size="SMALL" />
    </div>
  );
};

const RaindropEntry = () => {
  return (
    <div
      className={
        "flex flex-col h-full py-6 justify-around items-center overflow-x-visible gap-4"
      }
    >
      <div className="flex flex-col h-full items-center justify-center gap-4">
        <RaindropCircleAnimated />
        <div className="flex flex-col gap-1">
          <RaindropTitle size={Size.Large} />
          <p className=" w-full text-center font-black text-color-text-secondary">
            Finally, it's just simple.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4 items-center justify-center">
        <RaindropButton
          title={"Sign up"}
          style={ButtonStyle.Primary}
          to={"/raindrop/sign-up"}
          isFluid={true}
          size={Size.Large}
        />
        <RaindropButton
          title={"Log in"}
          to={"/raindrop/login"}
          style={ButtonStyle.Secondary}
          size={Size.Large}
        />
      </div>

      <RaindropCopyrightDeclaration />
    </div>
  );
};

export default RaindropEntry;
